import React from "react";
import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { WHAT_TO_EXPECT, FORMS, PAGE_BANNERS } from "../data/content";

export default function WhatToExpect() {
  const w = WHAT_TO_EXPECT;
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.clinic} alt="What to Expect" fallbackKey="clinic" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Visits / What to Expect</h1>

          <h3>Free 15 Minute Consultation</h3>
          <p>{w.freeConsult}</p>

          <h3>First Visit</h3>
          <p>{w.firstVisit.intro}</p>
          <ul>
            {w.firstVisit.bullets.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>

          <h3>What to Bring</h3>
          <ul>
            {w.whatToBring.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>

          <h3>Return Visits</h3>
          <p>{w.returnVisits.intro}</p>
          <ul>
            {w.returnVisits.bullets.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>

          <h3>Acute Visits</h3>
          <p>{w.acute}</p>

          <h3>Phone / TeleHealth Consultations</h3>
          <p>{w.telehealth}</p>

          <h3>New Patient Forms</h3>
          <ul>
            {FORMS.slice(0, 6).map((f) => (
              <li key={f.file}>
                <Link to="/clinic/download-forms" className="nn-link">
                  {f.label}
                </Link>
              </li>
            ))}
          </ul>

          <h3>Rates and Insurance</h3>
          <p>{w.insurance}</p>

          <h3>Payment</h3>
          <p>{w.payment}</p>

          <h3>Cancellation Policy</h3>
          <p>{w.cancellation}</p>

          <h3>Phone / Email Policy</h3>
          <p>{w.phoneEmail}</p>
        </article>
      </div>
    </div>
  );
}
